/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { Router } from "@angular/router";
import { ProductHomeService } from "src/app/features/product-feature/product-home/product-home.service";
import { MatDialogRef } from "@angular/material/dialog";
import { SigninComponent } from "src/app/features/auth-feature/signin/signin.component";

@Component({
  selector: "app-user-header",
  templateUrl: "./user-header.component.html",
  styleUrls: ["./user-header.component.scss"],
})
export class UserHeaderComponent implements OnInit {
  @Input() header: string;
  constructor(
    private router: Router,
    private home: ProductHomeService,
    private dialogRef: MatDialogRef<SigninComponent>
  ) {}
  ngOnInit() {}
  cancelfunction() {
    if (localStorage.getItem("isSupplier") === "true") {
      this.dialogRef.close();
      this.router.navigateByUrl("/");
      localStorage.setItem("isSupplier", "false");
    }
    this.dialogRef.close();
  }
}
